import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/styles';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import Button from 'components/buttons/Button';
import logoBlue from 'images/logo/logo_blue.svg';
import { verifyEmail, getUser } from 'redux/actions/userActions';

const styles = theme => ({
  wrapper: {
    backgroundColor: theme.palette.secondary.background,
    width: '100%',
    height: '80vh',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  logo: {
    marginBottom: '24px',
  },
});

function EmailVerification(props) {
  const redirect = async () => {
    const urlParams = new URLSearchParams(window.location.search);
    const key = urlParams.get('key');
    await props.verifyEmail({ key });
    await props.getUser();
    props.history.push('/');
  };

  return (
    <div className={props.classes.wrapper}>
      <img src={logoBlue} alt="PR Volt logo" className={props.classes.logo} />
      <Button
        variant="containedPrimaryCTA"
        size="medium"
        onClick={redirect}
      >
        Click to Verify Email
      </Button>
    </div>
  );
}

EmailVerification.propTypes = {
  classes: PropTypes.element.isRequired,
  verifyEmail: PropTypes.func.isRequired,
  getUser: PropTypes.func.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
};

export default compose(
  withStyles(styles, { withTheme: true }),
  withRouter,
  connect(
    null,
    { verifyEmail, getUser },
  ),
)(EmailVerification);
